import { ColumnDef } from '@tanstack/react-table';

import { SingleTransactionResponseType } from '../../../features/slice/accounting/transaction';
import { formatCurrencyInBDT } from '../../../utils/currency-formater';

export const transactionsColumns: ColumnDef<SingleTransactionResponseType>[] = [
    {
        accessorKey: 'created_at',
        header: 'Time',
        cell: ({ row }) => (
            <div className="font-medium">
                {row.original.created_at
                    ? new Date(row.original.created_at).toLocaleString()
                    : 'N/A'}
            </div>
        ),
    },

    {
        accessorKey: 'type',
        header: 'Type',
        cell: ({ row }) => (
            <div className="font-medium">{row.original.type || 'N/A'}</div>
        ),
    },

    {
        accessorKey: 'event_type',
        header: 'Event Type',
        cell: ({ row }) => (
            <div className="font-medium">
                {row.original.event_type || 'N/A'}
            </div>
        ),
    },

    {
        accessorKey: 'amount',
        header: 'Amount',
        cell: ({ row }) => (
            <div className="font-medium">
                {formatCurrencyInBDT(row.original.amount || 0)}
            </div>
        ),
    },

    {
        accessorKey: 'note',
        header: 'Note',
        cell: ({ row }) => (
            <div className="font-medium">{row.original.note || 'N/A'}</div>
        ),
    },
];
